// 游戏相关的术语配置
/**
 * 匹配模式
 */
export enum MatchEnum {
    '3+0' = '3+0',
    '5+3' = '5+0',
    '15+0' = '15+0',
    RANDOM = 'RANDOM',
}

/**
 * 游戏模式
 */
export enum GameModeEnum {
    /**
     * 好友PK
     */
    FRIEND_PK = 'FRIEND_PK',
    
    /**
     * 好友习题PK
     */
    SPRINT_FRIEND_PK = 'SPRINT_FRIEND_PK',

    /**
     * 人机对战
     */
    ROBOT = 'ROBOT',

    /**
     * 限时冲刺
     */
    SPRINT_EXERCISE = 'SPRINT_EXERCISE',
}

/**
 * 指令状态
 */
export enum OperateState {
    DISABLED = 'DISABLED',
    NORMAL = 'NORMAL',
    ACTIVE = 'ACTIVE',
    WAIT = 'WAIT',
}

export enum ExerciseEnum {
    OPEN = 'OPEN',
    STABLE = 'STABLE',
    RANDOM = 'RANDOM',
    SPRINT = 'SPRINT',
    SPRINT_FRIEND_PK = 'SPRINT_FRIEND_PK',
    OPEN_TREE = 'OPEN_TREE',
    OPEN_AI_TRAIN = 'OPEN_AI_TRAIN',
}
